/**
 * Copyright (c) 2026, CheckPlus Limited
 */
/* eslint-disable */
import React, { Component } from "react";
import "./OrgSetupBank.css";
import PropTypes from "prop-types";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { STRIPE_KEY } from "../../../config";

// Initialize Stripe outside component (singleton pattern for performance)
const stripePromise = loadStripe(STRIPE_KEY);
import AddBankForm from "./AddBankForm";
import { simpleFetch } from "../../../restWrapper";

class OrgSetupBank extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      bankAc: [],
    };
  }

  componentDidMount() {
    simpleFetch("/organizations/banks", "GET").then((res) => {
      this.setState({
        loading: false,
      });
      if (res.status !== 200) {
        return res;
      } else {
        this.setState({
          bankAc: res.body.data,
        });
      }
      return res;
    });
  }

  nextBtn = () => {
    if (this.state.bankAc.length > 0) {
      this.props.nextBtn();
    }
  };

  render() {
    if (this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }

    const nextBtn = () => {
      this.props.nextBtn();
    };

    const renderOrgBankAc = (ac) => {
      if (!ac) return;

      const onDelete = () => {
        this.setState({ loading: true });
        let bankInfo = this.state.bankAc;
        for (var i = 0; i < bankInfo.length; i++) {
          if (bankInfo[i].id === ac.id) {
            simpleFetch("/organizations/banks/deleteBank", "POST", {
              bankId: bankInfo[i].id,
              stripeAccountId: bankInfo[i].account,
            }).then((res) => {
              if ((res.body.deleted = true)) {
                this.setState({ loading: false });
                //this.props.history.push({ pathname: "/OrgSetupBank" });
                window.location.reload(true);
              }
            });
          }
        }
      };

      const onSetDefault = () => {
        this.setState({ loading: true });
        let bankInfo = this.state.bankAc;
        for (var i = 0; i < bankInfo.length; i++) {
          if (bankInfo[i].id === ac.id) {
            simpleFetch("/organizations/banks/updateBankAccount", "POST", {
              bankId: bankInfo[i].id,
              stripeAccountId: bankInfo[i].account,
            }).then((res) => {
              if ((res.body.deleted = true)) {
                this.setState({ loading: false });
                //this.props.history.push({ pathname: "/OrgSetupBank" });
                window.location.reload(true);
              }
            });
          }
        }
      };

      const key = ac.bank_name + ac.last4;

      return (
        <div className="OrgSetupBank-frame" key={key}>
          <div className="OrgSetupBank-toolbar">
            {this.state.bankAc.length > 1 ? (
              <div onClick={onDelete} className="OrgSetupBank-deleteBtn">
                <div className="OrgSetupBank-deleteIcn" />
              </div>
            ) : null}

            {ac.default_for_currency === true ? (
              <div className="OrgSetupBank-defaultBtn">
                <div className="OrgSetupBank-defaultIcn">Default</div>
              </div>
            ) : (
              <div
                onClick={onSetDefault}
                className="OrgSetupBank-setDefaultBtn"
              >
                <div className="OrgSetupBank-setDefaultIcn">Set to Default</div>
              </div>
            )}
          </div>

          <div className="OrgSetupBank-currency">
            <div className="OrgSetupBank-currencyText">
              {ac.currency.toUpperCase()}
            </div>
          </div>
          <div className="OrgSetupBank-text">
            <div className="OrgSetupBank-title">
              Bank
              <br />
              Account number
              <br />
              Account holder
            </div>
            <div className="OrgSetupBank-data">
              {ac.bank_name}
              <br />
              {ac.routing_number} •••• {ac.last4}
              <br />
              {ac.account_holder_name}
            </div>
          </div>
        </div>
      );
    };

    return (
      <div>
        {this.state.bankAc.length > 0 ? (
          <div className="OrgSetupBank-view">
            <div className="OrgSetupBank-center">
              <div className="OrgSetupBank-header">
                <div className="OrgSetupBank-CheckPlusLogo" />

                <div className="OrgSetupBank-headerBottom">
                  <div
                    className="OrgSetupBank-backBtn"
                    onClick={this.props.backBtn}
                  >
                    <div className="OrgSetupBank-backIcn" />
                  </div>

                  <div className="OrgSetupBank-steps">
                    Step 5 of 6: Add a Bank Account
                  </div>
                </div>
              </div>

              <div className="OrgSetupBank-heading">Saved bank accounts</div>

              <div className="OrgSetupBank-scrollContainer">
                {this.state.bankAc.map((ac) => renderOrgBankAc(ac))}

                <div className="OrgSetupBank-space" />
              </div>

              <div
                className="OrgSetupBank-logoutTxt"
                onClick={this.props.orgLogout}
              >
                Save and Log Out
              </div>

              {/* CP-304: payouts can be deferred. Profile and impact editing do
                  not wait on a bank account, so this step can be resumed later. */}
              <div
                className="OrgSetupBank-logoutTxt"
                onClick={this.props.skipPaymentsBtn || nextBtn}
                style={{ marginTop: 8 }}
              >
                {(this.props.languageObj &&
                  this.props.languageObj.setupPaymentsLater) ||
                  "Set up payments later"}
              </div>

              <div className="OrgSetupBank-nextBtn" onClick={nextBtn}>
                <div className="OrgSetupBank-nextIcnContainer">
                  <div className="OrgSetupBank-nextIcn" />
                </div>

                <div className="OrgSetupBank-nextText">Next</div>
              </div>
            </div>
          </div>
        ) : (
          <Elements stripe={stripePromise}>
            <AddBankForm
              languageObj={this.props.languageObj}
              backBtn={this.props.backBtn}
              nextBtn={this.props.nextBtn}
              skipPaymentsBtn={this.props.skipPaymentsBtn}
              orgLogout={this.props.orgLogout}
              RenderFullPageLoading={this.props.RenderFullPageLoading}
            />
          </Elements>
        )}
      </div>
    );
  }
}
OrgSetupBank.propTypes = {
  RenderFullPageLoading: PropTypes.func,
  backBtn: PropTypes.func,
  nextBtn: PropTypes.func,
  skipPaymentsBtn: PropTypes.func,
  orgLogout: PropTypes.func,
  languageObj: PropTypes.object,
};
export default OrgSetupBank;
